(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["v2-gift-message"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v2-gift-message')) {
  customElements.define('v2-gift-message', class extends HTMLElement {
    constructor() {
      super();
      this._timer = null;
      this._input = this.querySelector('[data-v2-gm-input]');
      this._count = this.querySelector('[data-v2-gm-count]');
      this._saved = this.querySelector('[data-v2-gm-saved]');
      if (!this._input) return;
      this._updateCount();
      this._input.addEventListener('input', this._onInput.bind(this));
    }
    _updateCount() {
      if (!this._count) return;
      var len = this._input.value.length;
      this._count.textContent = len + ' / 250';
      this._count.classList.toggle('is-near-limit', len > 220);
    }
    _onInput() {
      this._updateCount();
      clearTimeout(this._timer);
      this._timer = setTimeout(this._save.bind(this), 500);
    }
    _save() {
      var self = this;
      var body = JSON.stringify({ attributes: { 'Gift Message': this._input.value } });
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body
      }).then(function () {
        if (!self._saved) return;
        self._saved.classList.add('is-visible');
        setTimeout(function () { self._saved.classList.remove('is-visible'); }, 1600);
      }).catch(function () {});
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-gift-wrap"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v2-gift-wrap')) {
  customElements.define('v2-gift-wrap', class extends HTMLElement {
    constructor() {
      super();
      this._checkbox = this.querySelector('[data-v2-gw-checkbox]');
      if (!this._checkbox) return;
      this._variantId = this.dataset.variantId;
      this._checkbox.addEventListener('change', this._onToggle.bind(this));
    }
    _sections() {
      return ['main-cart-items', 'main-cart-footer', 'cart-drawer', 'cart-icon-bubble'];
    }
    async _onToggle() {
      var checked = this._checkbox.checked;
      this.classList.add('is-loading');
      try {
        if (checked) await this._add(); else await this._remove();
        this.classList.toggle('is-active', checked);
      } catch (e) {
        this._checkbox.checked = !checked;
        console.error('Gift wrap toggle failed:', e);
      } finally {
        this.classList.remove('is-loading');
      }
    }
    async _add() {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(this._variantId, 10), quantity: 1 }],
          sections: this._sections()
        })
      });
      if (!r.ok) throw new Error('add failed');
      var data = await r.json();
      this._applySections(data.sections);
      this._publishCartUpdate();
    }
    async _remove() {
      var r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: parseInt(this._variantId, 10),
          quantity: 0,
          sections: this._sections()
        })
      });
      if (!r.ok) throw new Error('remove failed');
      var data = await r.json();
      this._applySections(data.sections);
      this._publishCartUpdate();
    }
    _applySections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var target = document.getElementById('shopify-section-' + id);
        if (!target) return;
        var doc = new DOMParser().parseFromString(sections[id], 'text/html');
        var next = doc.getElementById('shopify-section-' + id);
        if (next) target.innerHTML = next.innerHTML;
      });
    }
    _publishCartUpdate() {
      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'v2-gift-wrap' });
        }
      } catch (e) {}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-pdp-photo-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var sections = document.querySelectorAll('[id^="v2-cpg-"]');
  sections.forEach(function (root) {
    if (root.dataset.v2CpgBound) return;
    root.dataset.v2CpgBound = '1';
    var dataEl = root.querySelector('[data-v2-cpg-data]');
    var dlg = root.querySelector('[data-v2-cpg-dlg]');
    if (!dataEl || !dlg) return;
    var items = [];
    try { items = JSON.parse(dataEl.textContent.trim()); } catch (e) { return; }
    if (!items.length) return;

    var img = dlg.querySelector('[data-v2-cpg-img]');
    var stars = dlg.querySelector('[data-v2-cpg-stars]');
    var head = dlg.querySelector('[data-v2-cpg-headline]');
    var text = dlg.querySelector('[data-v2-cpg-text]');
    var name = dlg.querySelector('[data-v2-cpg-name]');
    var dateWrap = dlg.querySelector('[data-v2-cpg-datewrap]');
    var dateEl = dlg.querySelector('[data-v2-cpg-date]');
    var idx = 0;

    function renderStars(n) {
      n = parseFloat(n) || 0;
      var s = '';
      for (var i = 1; i <= 5; i++) {
        s += i <= Math.round(n) ? '★' : '☆';
      }
      return s;
    }
    function show(i) {
      idx = (i + items.length) % items.length;
      var it = items[idx];
      img.src = it.src; img.alt = (it.headline || 'Customer photo') + ' by ' + (it.name || '');
      stars.textContent = renderStars(it.rating);
      head.textContent = it.headline || '';
      head.style.display = it.headline ? '' : 'none';
      text.textContent = it.body || '';
      text.style.display = it.body ? '' : 'none';
      name.textContent = it.name || 'Anonymous';
      if (it.date) { dateEl.textContent = it.date; dateWrap.style.display = ''; }
      else dateWrap.style.display = 'none';
    }
    function open(i) {
      show(i);
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
    }
    function close() {
      if (typeof dlg.close === 'function') dlg.close();
      else dlg.removeAttribute('open');
    }

    root.querySelectorAll('[data-v2-cpg-tile]').forEach(function (t) {
      t.addEventListener('click', function () { open(parseInt(t.dataset.index, 10) || 0); });
    });
    dlg.querySelector('[data-v2-cpg-prev]').addEventListener('click', function () { show(idx - 1); });
    dlg.querySelector('[data-v2-cpg-next]').addEventListener('click', function () { show(idx + 1); });
    dlg.querySelectorAll('[data-v2-cpg-close]').forEach(function (b) { b.addEventListener('click', close); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    document.addEventListener('keydown', function (e) {
      if (!dlg.open) return;
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
      if (e.key === 'Escape') close();
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-pdp-qa"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';
  var sections = document.querySelectorAll('[id^="v2-qa-"]');
  sections.forEach(function (section) {
    if (section.dataset.v2QaBound) return;
    section.dataset.v2QaBound = '1';
    var dlg = section.querySelector('[data-v2-qa-dlg]');
    if (!dlg) return;
    var opens = section.querySelectorAll('[data-v2-qa-open]');
    var closes = section.querySelectorAll('[data-v2-qa-close]');
    opens.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
      });
    });
    closes.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (typeof dlg.close === 'function') dlg.close();
        else dlg.removeAttribute('open');
      });
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) {
        if (typeof dlg.close === 'function') dlg.close();
      }
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-pdp-zoom"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var panel = document.getElementById('v2-zoom-panel');
  var lens = document.getElementById('v2-zoom-lens');
  if (!panel || !lens) return;

  var ZOOM = 2.6;
  var PANEL_W = 460;
  var PANEL_H = 460;
  var LENS_W = 120;
  var LENS_H = 120;
  var GUTTER = 20;
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  function activeMediaImage() {
    var active = document.querySelector('.product__media-item.is-active');
    if (!active) return null;
    var img = active.querySelector('.product__media img');
    return img && img.complete && img.naturalWidth > 0 ? img : null;
  }

  function largestSrc(img) {
    if (img.currentSrc) return img.currentSrc;
    if (img.srcset) {
      var parts = img.srcset.split(',').map(function (p) { return p.trim(); });
      var last = parts[parts.length - 1];
      if (last) return last.split(' ')[0];
    }
    return img.src;
  }

  var currentImg = null;
  var rafId = null;
  var pendingEvent = null;

  function onMove(e) {
    pendingEvent = e;
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      render(pendingEvent);
    });
  }

  function render(e) {
    if (!currentImg || !e) return;
    var rect = currentImg.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    if (x < 0 || y < 0 || x > rect.width || y > rect.height) return;

    var xPct = x / rect.width;
    var yPct = y / rect.height;

    var bgW = rect.width * ZOOM;
    var bgH = rect.height * ZOOM;
    var bgX = -(xPct * (bgW - PANEL_W));
    var bgY = -(yPct * (bgH - PANEL_H));

    panel.style.backgroundSize = bgW + 'px ' + bgH + 'px';
    panel.style.backgroundPosition = bgX + 'px ' + bgY + 'px';

    var preferRight = (rect.right + GUTTER + PANEL_W) <= window.innerWidth;
    var panelLeft = preferRight
      ? rect.right + GUTTER
      : Math.max(GUTTER, rect.left - GUTTER - PANEL_W);
    var panelTop = Math.max(GUTTER, Math.min(rect.top, window.innerHeight - PANEL_H - GUTTER));
    panel.style.left = panelLeft + 'px';
    panel.style.top = panelTop + 'px';

    var lensLeft = e.clientX - LENS_W / 2;
    var lensTop = e.clientY - LENS_H / 2;
    var minLeft = rect.left;
    var maxLeft = rect.right - LENS_W;
    var minTop = rect.top;
    var maxTop = rect.bottom - LENS_H;
    lens.style.left = Math.max(minLeft, Math.min(lensLeft, maxLeft)) + 'px';
    lens.style.top = Math.max(minTop, Math.min(lensTop, maxTop)) + 'px';
  }

  function onEnter(e) {
    if (!mq.matches) return;
    var img = e.currentTarget;
    if (!img || !img.complete || img.naturalWidth === 0) return;
    currentImg = img;
    panel.style.backgroundImage = 'url("' + largestSrc(img) + '")';
    panel.classList.add('is-visible');
    lens.classList.add('is-visible');
    var item = img.closest('.product__media-item');
    if (item) item.classList.add('v2-zoom-active');
    render(e);
  }

  function onLeave() {
    currentImg = null;
    panel.classList.remove('is-visible');
    lens.classList.remove('is-visible');
    document.querySelectorAll('.product__media-item.v2-zoom-active').forEach(function (el) {
      el.classList.remove('v2-zoom-active');
    });
  }

  var bound = new WeakSet();
  function bindImages() {
    if (!mq.matches) return;
    document.querySelectorAll('.product__media-item .product__media img').forEach(function (img) {
      if (bound.has(img)) return;
      bound.add(img);
      img.addEventListener('mouseenter', onEnter);
      img.addEventListener('mousemove', onMove);
      img.addEventListener('mouseleave', onLeave);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindImages, { once: true });
  } else {
    bindImages();
  }
  window.addEventListener('load', bindImages, { once: true });

  var observer = new MutationObserver(function () { bindImages(); });
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('scroll', onLeave, { passive: true });
  window.addEventListener('resize', onLeave);
  mq.addEventListener && mq.addEventListener('change', function (ev) { if (!ev.matches) onLeave(); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v2-stock-urgency"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var container = document.getElementById('v2-stock-urgency');
  if (!container) return;
  var textEl = document.getElementById('v2-stock-urgency-text');
  if (!textEl) return;

  var THRESHOLD = 5;
  var dataNodes = document.querySelectorAll('script[data-v2-stock-variant]');
  var inventoryMap = {};
  var titleMap = {};
  dataNodes.forEach(function (node) {
    var id = node.getAttribute('data-v2-stock-variant');
    var qty = parseInt((node.textContent || '').trim(), 10);
    if (!isNaN(qty)) {
      inventoryMap[id] = qty;
      titleMap[id] = node.getAttribute('data-v2-stock-title') || '';
    }
  });

  if (Object.keys(inventoryMap).length === 0) return;

  function getCurrentVariantId() {
    var urlVar = new URLSearchParams(window.location.search).get('variant');
    if (urlVar) return urlVar;
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;
    return container.dataset.initialVariant;
  }

  function update(variantId) {
    var qty = inventoryMap[variantId];
    if (qty === undefined || qty <= 0 || qty >= THRESHOLD) {
      container.classList.remove('v2-stock-urgency--visible');
      return;
    }
    var title = titleMap[variantId] || '';
    var variantHint = title && title !== 'Default Title' ? ' in ' + title : '';
    textEl.textContent = qty === 1
      ? 'Only 1 left' + variantHint + ' — order soon'
      : 'Only ' + qty + ' left' + variantHint;
    container.classList.add('v2-stock-urgency--visible');
  }

  update(getCurrentVariantId());

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest('form[action*="/cart/add"]')) {
      setTimeout(function () { update(getCurrentVariantId()); }, 60);
    }
  });

  document.addEventListener('variant:changed', function (e) {
    var vId = (e.detail && e.detail.variant && e.detail.variant.id) || getCurrentVariantId();
    update(vId);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["valino-back-in-stock"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  var widget = document.getElementById('vbis-widget');
  if (!widget) return;

  var productId = widget.dataset.productId;
  var formWrap = document.getElementById('vbis-form-wrap');
  var emailInput = document.getElementById('vbis-email');
  var submitBtn = document.getElementById('vbis-submit');
  var successMsg = document.getElementById('vbis-success');

  function checkVariantAvailability() {
    var atcBtn = document.querySelector('[name="add"]') || document.querySelector('.product-form__submit');
    if (!atcBtn) return;
    var isDisabled = atcBtn.disabled || atcBtn.classList.contains('disabled') || atcBtn.getAttribute('aria-disabled') === 'true';
    var btnText = (atcBtn.textContent || '').toLowerCase();
    var soldOut = isDisabled || btnText.includes('sold out') || btnText.includes('unavailable');
    widget.style.display = soldOut ? 'block' : 'none';
  }

  checkVariantAvailability();

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest('form[action*="/cart/add"]')) {
      setTimeout(checkVariantAvailability, 100);
    }
  });

  document.addEventListener('variant:changed', function () {
    setTimeout(checkVariantAvailability, 100);
  });

  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var email = emailInput ? emailInput.value.trim() : '';
      if (!email || !email.includes('@')) {
        emailInput && (emailInput.style.borderColor = '#E11D30');
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = '...';

      var formData = new FormData();
      formData.append('contact[email]', email);
      formData.append('contact[tags]', 'back-in-stock');
      formData.append('contact[note]', 'Back in stock request for product ID: ' + productId + ' on ' + window.location.href);
      formData.append('form_type', 'customer');

      fetch('/contact', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      }).catch(function () {}).finally(function () {
        formWrap.classList.add('vbis--hidden');
        successMsg.classList.add('vbis--visible');
        try {
          var key = 'vbis_' + productId;
          localStorage.setItem(key, email);
        } catch (e) {}
      });
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
